import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../common/Loader.js';
import Button from '../common/Button.js';
import authService from '../../services/authService';
import { useTranslation } from 'react-i18next';
import { Mail, Send, ArrowLeft } from 'lucide-react';
import AuthLayout, { authInputClass, authIconClass, authLabelClass, authPrimaryBtnClass, authOutlineLinkClass } from './AuthLayout.js';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      setMessage(response.message || 'OTP sent successfully to your email');

      sessionStorage.setItem('resetEmail', email);

      setTimeout(() => {
        navigate('/reset-password');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Show loader when sending OTP
  if (loading) {
    return <Loader fullScreen={true} size="default" message="Sending OTP to your email..." />
  }

  return (
    <AuthLayout title="Forgot Password" subtitle="Enter your registered email to receive an OTP">
      {/* ERROR MESSAGE */}
      {error && (
        <div className="mb-5 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
          {error}
        </div>
      )}

      {/* SUCCESS MESSAGE */}
      {message && (
        <div className="mb-5 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-sm">
          {message}
          <p className="text-xs mt-1 text-green-600">
            Redirecting to reset password...
          </p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* EMAIL INPUT */}
        <div>
          <label className={authLabelClass}>Email Address</label>
          <div className="relative">
            <Mail className={authIconClass} strokeWidth={1.75} />
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`${authInputClass} pl-12 pr-4`}
              required
              disabled={loading}
            />
          </div>
        </div>

        {/* SEND OTP BUTTON */}
        <Button
          variant="primary"
          type="submit"
          fullWidth
          loading={loading}
          size="lg"
          icon={Send}
          className={authPrimaryBtnClass}
        >
          {loading ? 'SENDING OTP...' : 'SEND OTP'}
        </Button>

        {/* BACK TO LOGIN */}
        <div className="pt-1">
          <Link to="/login" className={authOutlineLinkClass}>
            <ArrowLeft className="w-4 h-4" />
            Back to Login
          </Link>
        </div>

        <p className="pt-2 text-[11px] leading-relaxed text-slate-400 text-center">
          By continuing, you accept our{' '}
          <span className="text-blue-600">Terms &amp; Conditions</span> and{' '}
          <span className="text-blue-600">Privacy Policy</span>.
        </p>
      </form>
    </AuthLayout>
  );
};


export default ForgotPassword;